export default __webpack_public_path__ + "static/media/gloves2.5bb071c8.jpg";